import { TextAreaField } from "@components/forms/TextAreaField";
import { type Control, Controller, type FieldPath } from "react-hook-form";
import type { TicketFormData } from "../../config/schemas";

/** TextArea wrapped in Controller for react-hook-form integration */
export function ControlledTextArea({
  name,
  control,
  label,
  placeholder,
  rows = 4,
  error,
  maxLength,
}: {
  name: FieldPath<TicketFormData>;
  control: Control<TicketFormData>;
  label?: string;
  placeholder?: string;
  rows?: number;
  error?: string;
  maxLength?: number;
}) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <TextAreaField
          label={label}
          placeholder={placeholder}
          value={String(field.value ?? "")}
          onChange={(val) => field.onChange(val || "")}
          rows={rows}
          error={fieldState.error?.message ?? error}
          maxLength={maxLength}
        />
      )}
    />
  );
}
